import { SvgIcon } from '@mui/material';

const Saturday = props => (
  <SvgIcon width='33.17' height='35.934' viewBox='0 0 33.17 35.934' {...props}>
    <g id='Group_182' data-name='Group 182' transform='translate(0 0)'>
      <path
        id='Path_91'
        data-name='Path 91'
        d='M23.622,34.159h1.949l-.963-2.693Z'
        transform='translate(-7.913 -10.7)'
        fill='#dc0032'
      />
      <g id='Group_181' data-name='Group 181' transform='translate(0 0.001)'>
        <g id='Group_180' data-name='Group 180'>
          <path
            id='Path_92'
            data-name='Path 92'
            d='M32.361,3.574a2.764,2.764,0,0,0-1.955-.809H26.26V1.382a1.382,1.382,0,0,0-2.764,0V2.765H9.675V1.382a1.382,1.382,0,0,0-2.765,0V2.765H2.765A2.763,2.763,0,0,0,0,5.528V33.17a2.763,2.763,0,0,0,2.765,2.764H30.406A2.762,2.762,0,0,0,33.17,33.17V5.528a2.764,2.764,0,0,0-.809-1.955M9.387,26.353a6.422,6.422,0,0,1-2.7-.628l.478-1.788a4.151,4.151,0,0,0,2.256.724c.6,0,.947-.18.947-.574,0-.256-.212-.416-.659-.543l-1.15-.33c-1.224-.351-1.841-.969-1.841-2.022,0-1.277,1-2.277,2.937-2.277a6.5,6.5,0,0,1,2.629.575l-.575,1.692a4.822,4.822,0,0,0-2.139-.575c-.554,0-.788.181-.788.479,0,.234.149.351.532.468l1.246.362c1.352.4,1.893,1.064,1.893,2.044,0,1.4-1.2,2.394-3.064,2.394m9.14-.107-.436-1.224H15.271l-.426,1.224H12.781l2.713-7.237H17.9l2.692,7.237Zm7.959-5.46H24.433v5.46H22.389v-5.46H20.314V19.009h6.172Zm3.92-9.73H2.765V5.528H6.911V6.911a1.382,1.382,0,0,0,2.765,0V5.528H23.5V6.911a1.382,1.382,0,0,0,2.764,0V5.528h4.146Z'
            transform='translate(0 0)'
            fill='#dc0032'
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export default Saturday;
